import { FormValidator, type FormValidatorContext, type FormValidatorConfig, type FormValidatorSettings, isEmpty } from '@common/index';
import { useApi } from '../../../services';

export type EducationMonthUniqueValidatorSettings = FormValidatorSettings;

export type EducationMonthUniqueValidatorConfig = FormValidatorConfig<EducationMonthUniqueValidatorSettings>;

export class EducationMonthUniqueValidator extends FormValidator<EducationMonthUniqueValidatorSettings> {
  educationMonthApi = useApi().educationMonth;

  constructor() {
    super();
    this._name = 'educationMonthUnique';
    this._settings = {
      invalidMessage: 'form.validator.educationMonthUnique.invalidMessage',
      needTranslate: true
    };
  }

  public override async onValidate(value: any, context: FormValidatorContext) {
    if (isEmpty(value)) {
      return;
    }
    const params = {
      id: context.element.parent?.value?.id || 0,
      educationId: context.element.parent?.value?.educationId || null,
      monthDate: context.element.parent?.value?.monthDate || null
    };
    const response = await this.educationMonthApi.validateMonth(params);

    if (response.data.valid) {
      this._valid = true;
    } else {
      this.addMessage(response.data.errorMessage || this.settings.invalidMessage);
      this._valid = false;
    }
  }
}
